function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M125.7 245.7c0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120-120 53.8-120 120zm224 0c0 57.3-46.7 104-104 104s-104-46.7-104-104 46.7-104 104-104 104 46.6 104 104z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M157.7 245.7c0 20.2 7.1 40 19.9 55.7l12.4-10.1c-10.5-12.8-16.3-29-16.3-45.5 0-39.7 32.3-72 72-72 16.6 0 32.7 5.8 45.6 16.3l10.1-12.4c-15.7-12.8-35.4-19.9-55.7-19.9-48.6-.1-88 39.3-88 87.9zM245.7 317.7c-16.6 0-32.7-5.8-45.6-16.3L190 313.8c15.7 12.8 35.4 19.9 55.7 19.9 48.5 0 88-39.5 88-88 0-20.2-7.1-40-19.9-55.7l-12.4 10.1c10.5 12.8 16.3 29 16.3 45.5 0 39.8-32.3 72.1-72 72.1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M143.4 116.6l102.3-22.8 136 30.3v153.6h16V111.2l-152-33.7L139.9 101zM45.7 125.7h16v16h-16z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M445.7 381.7h-16v40H444l-38.4 43.8-38.4-43.8h14.4V329l109.7-109.7L480 208 365.7 322.3v16c-9.3 14-22 25.4-37.1 32.9l-82.9 41.5-82.9-41.5c-32.7-16.4-53.1-49.3-53.1-85.9V185l16-16V85.7h33.6L85.7 1.5 12 85.7h33.6v24h16v-40H47.3l38.4-43.8L124 69.7h-14.4v92.7L0 272l11.3 11.3L93.7 201v84.4c0 42.7 23.7 81.1 61.9 100.2l90.1 45 90.1-45c11.2-5.6 21.2-13.2 29.9-22.2v42.3H332l73.6 84.2 73.6-84.2h-33.6l.1-24z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M429.7 349.7h16v16h-16zM314.8 269.1c-2.2 5.5-5 10.8-8.5 15.6H273v-42.2L245.7 276l-27.4-33.4v42.2h-33.2c-3.5-4.8-6.3-10.1-8.5-15.6h26.1v-70.4l43 52.6 43-52.6v70.4l26.1-.1z"
});

var SvgIconConfidential = function SvgIconConfidential(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 491.3 491.3",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconConfidential, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-confidential.55857a42.svg";
export { ForwardRef as ReactComponent };